
import offer_1 from '../image/Education/offer-1.png';
import offer_2 from '../image/Education/offer-2.png';
import offer_3 from '../image/Education/offer-3.png';
import offer_4 from '../image/Education/offer-4.png';
import resource_1 from '../image/Education/resource-1.png';
import resource_2 from '../image/Education/resource-2.png';
import resource_3 from '../image/Education/resource-3.png';
import resource_4 from '../image/Education/resource-4.png';

import icon_1 from '../image/icon/culture.png';
import icon_2 from '../image/icon/knowledge.png';
import icon_3 from '../image/icon/creative.png';
import icon_4 from '../image/icon/growth.png';

import product_1 from '../image/shop/product-1.png';
import product_2 from '../image/shop/product-2.png';
import product_3 from '../image/shop/product-3.png';
import product_4 from '../image/shop/product-4.png';


import male from '../image/male.png';
import women from '../image/women.png';

import D_icon_1 from '../image/icon/icon-1.png';
import D_icon_2 from '../image/icon/icon-2.png';
import D_icon_3 from '../image/icon/icon-3.png';
import D_icon_4 from '../image/icon/icon-4.png';
import D_icon_5 from '../image/icon/icon-5.png';

import { CgProfile,CgAwards } from "react-icons/cg";
import { SiOpenbadges } from "react-icons/si";
import { MdOutlineCastForEducation } from "react-icons/md";
import { LuMessageSquare } from "react-icons/lu";
import { GrProjects } from "react-icons/gr";
import { FaQuestion } from "react-icons/fa";
import { MdQuiz } from "react-icons/md";
import p_1 from '../image/projects/p-1.jpg';
import p_2 from '../image/projects/p-2.webp';
import p_3 from '../image/projects/p-3.jpg';
import p_4 from '../image/projects/p-4.webp';
import p_5 from '../image/projects/p-5.webp';
import p_6 from '../image/projects/p-6.jpg';
import p_7 from '../image/projects/p-7.png';
import p_8 from '../image/projects/p-8.jpg';
import p_9 from '../image/projects/p-9.jpg';
import p_10 from '../image/projects/p-10.jpg';
import avatar from '../image/projects/avatar.avif'

export const Education_Offers=[
     {
        id:1,
        title:"Guided Online Lessons",
        description:"Fundamentals to advanced techniques in each discipline, delivered in video, or downloadable formats.",
        image:offer_1
     },
     {
        id:2,
        title:"Craft Workshops & Live Reviews",
        description:"Faculty and reviewers host digital workshops where members can submit work for critique.",
        image:offer_2
     },
     {
        id:3,
        title:"Real Artist Case Studies",
        description:"Breakdowns of past submissions, why they worked, and what can be improved.",
        image:offer_3
     },
     {
        id:4,
        title:"Masterclasses & Guest Experts",
        description:"Deep-dive interviews and sessions with guest architects, photographers, sculptors, and designers.",
        image:offer_4
     },
      {
        id:5,
        title:"Guided Online Lessons",
        description:"Fundamentals to advanced techniques in each discipline, delivered in video, or downloadable formats.",
        image:offer_1
     },
     {
        id:6,
        title:"Craft Workshops & Live Reviews",
        description:"Faculty and reviewers host digital workshops where members can submit work for critique.",
        image:offer_2
     },
     {
        id:7,
        title:"Real Artist Case Studies",
        description:"Breakdowns of past submissions, why they worked, and what can be improved.",
        image:offer_3
     },
     {
        id:8,
        title:"Masterclasses & Guest Experts",
        description:"Deep-dive interviews and sessions with guest architects, photographers, sculptors, and designers.",
        image:offer_4
     },
]


export const Education_Resources=[
      {
        id:1,
        title:"Architecture",
        detail:"Study conceptual theories, spatial logic, functional planning, environmental design, and industry presentation standards.",
        image:offer_1
      },
      {
        id:2,
        title:"Photography",
        detail:"Master composition, lighting, visual storytelling, emotional resonance, gear usage, and professional post-production.",
        image:offer_2
      },
      {
        id:3,
        title:"Sculpture",
        detail:"Explore material handling, volume, texture, conceptual interpretation, 3D form logic, and exhibition methods.",
        image:offer_3
      },
      {
        id:4,
        title:"Design & Media",
        detail:"Focus on digital rendering, 3D tools, generative art, hybrid workflows, and modern creative pipelines.",
        image:offer_4
      },
]

export const Refine_Resources=[
      {
        id:"technical-skills",
        title:"Technical Skills",
        detail:"Build practical foundations in camera control, composition, lighting, editing, presentation, and responsible field practice.",
        image:offer_1,
        intro:"Technical Skills is focused on craft decisions members can use immediately: how to plan the image, control the camera, shape light, edit with restraint, and prepare finished work for review or submission.",
        documentFlow:[
          {
            label:"Welcome Message",
            title:"Build stronger images through practical craft",
            body:"Use this Technical Skills path as a working guide for making clearer, more intentional photographs. The goal is not to add business advice here. This page is only about the creative and technical choices that improve the image itself."
          },
          {
            label:"Brief of the Skill Path",
            title:"What this area covers",
            body:"This path helps members improve capture, composition, light, editing, file preparation, and responsible field practice. It is designed for quest submissions, gallery-ready work, critique sessions, and personal portfolio development."
          },
          {
            label:"Practice Prompt",
            title:"Create a focused technical study",
            body:"Choose one subject and photograph it with 1-2 intentional technical goals. For example, control backlight, simplify the background, show motion, preserve highlight detail, or create a stronger visual sequence. Add a short note explaining the technical choices you made and what changed between attempts."
          },
          {
            label:"Example Skill Sections",
            title:"Where to begin",
            items:[
              "Camera control: aperture, shutter speed, ISO, focus mode, white balance, and exposure compensation.",
              "Composition: subject placement, leading lines, frame edges, negative space, color, rhythm, and contrast.",
              "Lighting: direction, softness, color temperature, shadow control, natural light, reflected light, and timing.",
              "Editing: crop, exposure, tone, color balance, local adjustments, export settings, and file organization."
            ]
          },
          {
            label:"What Strong Technical Choices Convey",
            title:"Why technique matters",
            body:"Technical choices help viewers understand what matters in the image. Clear focus, intentional light, restrained editing, and careful framing can turn a simple subject into a stronger story. The goal is not perfection for its own sake. The goal is to support meaning, mood, and clarity."
          },
          {
            label:"How Progress Can Be Reviewed",
            title:"Review criteria",
            items:[
              "Clarity and focus: the subject is readable and technically controlled.",
              "Composition: the frame guides attention without unnecessary distractions.",
              "Lighting and exposure: the image keeps important detail and uses light intentionally.",
              "Editing discipline: post-processing supports the photograph without making it look artificial.",
              "Submission readiness: files are named, sized, formatted, and prepared according to the requested instructions."
            ]
          },
          {
            label:"Practice Standards",
            title:"Before you submit or share",
            items:[
              "Use original images and keep a copy of the original file.",
              "Avoid heavy manipulation when the assignment asks for natural or documentary work.",
              "Confirm file format, size, EXIF, location, release, and upload requirements before submitting.",
              "Respect people, property, and cultural context when photographing in public or private spaces."
            ]
          }
        ],
        sections:[
          {
            title:"Camera and Exposure",
            description:"Build confidence with the controls that shape every photograph before editing begins.",
            items:[
              "Use aperture, shutter speed, and ISO intentionally instead of relying only on automatic settings.",
              "Check focus mode, white balance, file format, and exposure compensation before a shoot.",
              "Review histograms and highlights so bright areas keep usable detail.",
              "ISO Simply Explained in Minutes by Simon d'Entremont: a focused YouTube lesson on ISO, noise reduction, and technical proficiency. https://www.youtube.com/watch?v=svW8UYpEDrc"
            ]
          },
          {
            title:"Composition and Visual Design",
            description:"Make stronger images by arranging subject, space, line, rhythm, and background with purpose.",
            items:[
              "Place the subject clearly and remove visual distractions around the frame edges.",
              "Use leading lines, foreground elements, negative space, symmetry, or contrast to guide attention.",
              "Create a small sequence of images so the story is not carried by one photograph alone."
            ]
          },
          {
            title:"Lighting and Timing",
            description:"Understand the mood and clarity created by available light, artificial light, and time of day.",
            items:[
              "Observe light direction, softness, color, and shadow shape before choosing a position.",
              "Use golden hour, open shade, window light, or bounced light to reduce harsh contrast.",
              "Keep safety and access in mind when photographing public places or active streets."
            ]
          },
          {
            title:"Editing and File Preparation",
            description:"Use post-processing to support the image instead of covering weak capture decisions.",
            items:[
              "Start with crop, exposure, contrast, color balance, and local adjustments before heavy effects.",
              "Export files at the requested size, format, and naming convention for each quest or review.",
              "Keep original files and edited versions organized so submissions can be traced later."
            ]
          },
          {
            title:"Ethics, Releases, and Permissions",
            description:"Respect people, places, and ownership when turning images into public work.",
            items:[
              "Ask permission when a person is identifiable and the use may be sensitive or commercial.",
              "Avoid misrepresenting culture, community, or events through captions and editing choices.",
              "Understand basic copyright, licensing, and attribution before sharing finished work."
            ]
          }
        ],
        externalLinks:[
          {
            title:"Adobe Lightroom Tutorials",
            url:"https://helpx.adobe.com/lightroom-cc/tutorials.html",
            description:"Official Lightroom lessons for editing, organizing, presets, local adjustments, and beginner workflows."
          },
          {
            title:"Canon Learning Center",
            url:"https://www.usa.canon.com/learning",
            description:"Training articles and inspiration for photography basics, camera technique, and creative growth."
          },
          {
            title:"Nikon Learn and Explore",
            url:"https://www.nikonusa.com/redirect/en/learn-and-explore/a/tips-and-techniques/photography-101-understanding-the-basics.html",
            description:"Photography article collections, technique guides, and camera-learning resources."
          },
          {
            title:"Cambridge in Colour Tutorials",
            url:"https://www.cambridgeincolour.com/",
            description:"Clear learning material for exposure, depth of field, natural light, histograms, lenses, and sharpening."
          },
          {
            title:"U.S. Copyright Office: Photographs",
            url:"https://www.copyright.gov/registration/photographs/",
            description:"Official guidance for registering photographic work and understanding protected photo categories."
          },
          {
            title:"Creative Commons Licenses",
            url:"https://creativecommons.org/share-your-work/cclicenses/",
            description:"Learn how CC licenses work before sharing or reusing creative work."
          }
        ]
      },
      {
        id:"business-and-career-tips",
        title:"Business and Career Tips",
        detail:"Learn how to present work, price responsibly, prepare portfolios, apply for opportunities, and manage a creative practice.",
        image:offer_2,
        intro:"Business and Career Tips keeps the professional material separate from technical craft. This page focuses on portfolio readiness, pricing, licensing, submissions, client communication, and sustainable creative habits.",
        sections:[
          {
            title:"Portfolio and Presentation",
            description:"Show a focused body of work that communicates a clear creative point of view.",
            items:[
              "Lead with your strongest work and remove pieces that weaken the story.",
              "Group images by theme, project, discipline, or audience instead of uploading everything.",
              "Write concise captions that explain subject, intent, context, and process."
            ]
          },
          {
            title:"Pricing, Rights, and Licensing",
            description:"Treat images and creative labor as assets with terms, scope, and value.",
            items:[
              "Separate creation fees, usage rights, expenses, and revision terms when quoting work.",
              "Clarify where, how long, and how broadly a client or partner may use the work.",
              "Keep written records of permissions, licenses, and delivery terms."
            ]
          },
          {
            title:"Applications and Opportunities",
            description:"Prepare for grants, exhibitions, residencies, commissions, and community showcases.",
            items:[
              "Keep a current artist bio, project statement, resume, and image list ready.",
              "Match your proposal to the opportunity instead of sending one generic application.",
              "Track deadlines, required file sizes, eligibility rules, and follow-up dates."
            ]
          }
        ],
        externalLinks:[
          {
            title:"SBA Business Guide",
            url:"https://www.sba.gov/business-guide",
            description:"Official U.S. small-business guidance for planning, launching, managing, and growing a business."
          },
          {
            title:"U.S. Copyright Office for Photographers",
            url:"https://www.copyright.gov/engage/photographers/",
            description:"Official overview of copyright basics photographers should understand."
          },
          {
            title:"ASMP Releases for Professionals",
            url:"https://www.asmp.org/strictly-business-blog/releases-for-professionals/",
            description:"Professional guidance on model and property releases for commercial image use."
          }
        ]
      },
      {
        id:"workshops-and-seminars",
        title:"Workshops and Seminars",
        detail:"Find guided sessions, live reviews, guest experts, critique circles, and focused learning events for creative development.",
        image:offer_3,
        intro:"Workshops and Seminars is the place for live learning and guided group development. Use it to connect technique, feedback, and community conversation.",
        sections:[
          {
            title:"Live Learning Sessions",
            description:"Structured sessions for members who want a focused topic and practical takeaways.",
            items:[
              "Attend technique workshops tied to current quests, galleries, and member needs.",
              "Bring specific questions or examples so the session can be useful and direct.",
              "Save notes and action items after each session for your next submission."
            ]
          },
          {
            title:"Critique and Review",
            description:"Improve by seeing how other artists read your work and how you read theirs.",
            items:[
              "Share work-in-progress when you need direction, not only finished images.",
              "Ask for feedback on composition, editing, sequence, message, or technical execution.",
              "Use critique notes to revise one clear area before moving to the next."
            ]
          },
          {
            title:"Guest Experts and Community Events",
            description:"Learn from outside voices while staying connected to the LWBL community path.",
            items:[
              "Look for announcements tied to quests, galleries, mentorship, and community gatherings.",
              "Prepare a short introduction to your work before joining a live review.",
              "Follow up after events by updating your profile, gallery, or next project plan."
            ]
          }
        ],
        externalLinks:[
          {
            title:"LWBL Community",
            url:"/community",
            description:"Visit the community area for gatherings, discussions, and member connection."
          },
          {
            title:"LWBL Quests",
            url:"/quests",
            description:"Use current quests as prompts for workshop practice and critique preparation."
          },
          {
            title:"Mentor Messages",
            url:"/mentor-messages",
            description:"Ask direct questions when you need guidance on a specific creative problem."
          }
        ]
      },
]


export const Community_voice=[
  {
    id:1,
    title:"Encouragement Culture",
    description:"A space grounded in empathy, kindness, and constructive conversation.",
    icon:icon_1,
  },
  {
    id:2,
    title:"Shared Knowledge",
    description:"Members exchange techniques, insights, and lessons learned from real creative journeys.",
    icon:icon_2,
  },
  {
    id:3,
    title:"Safe Creative Haven",
    description:"Protected spaces with strong privacy, secure data, and an inclusive environment.",
    icon:icon_3,
  },
  {
    id:4,
    title:"Growth Through Feedback",
    description:"Members learn from critiques, challenge insights, and shared review notes.",
    icon:icon_4,
  }
]


export const Community_connects=[
  {
    id:1,
    title:"Discussion Forums",
    description:"Topic-based spaces for architecture, photography, sculpture, and technical design.",
   
  },
  {
    id:2,
    title:"Member Showcases",
    description:"Share personal works-in-progress, get encouragement, and offer feedback to peers.",
  },
  {
    id:3,
    title:"Ask-the-Mentors",
    description:"A guided Q&A hub where experts address technique, storytelling, and discipline-specific questions.",
  },
  {
    id:4,
    title:"Creative Challenges",
    description:"A community arena to discuss upcoming themes, strategies, and interpretations.",
  },
  {
    id:5,
    title:"CGroup Study Circles",
    description:"Small cohorts focused on specific skill-building topics or creative disciplines.",
  }
]

export const Community_path=[
     {
      id:1,
      title:"Create Your Profile",
      detail:"Tell us about your discipline, interests, and creative passions.",
      path:"/profile",
      action:"Edit profile",
     },
     {
      id:2,
      title:"Join a Discussion",
      detail:"Start with something small—introductions, a technique query, or an inspiration post.",
      path:"/discussions",
      action:"Join discussion",
     },
     {
      id:3,
      title:"Upload",
      detail:"Show your development and get gentle, constructive feedback.",
      path:"/quests",
      action:"View quests",
     },
     {
      id:4,
      title:"Participate",
      detail:"Try a poll, mini challenge, or peer review session.",
      path:"/quiz",
      action:"Participate",
     },
     {
      id:5,
      title:"Connect",
      detail:"Follow members, comment on posts, and build meaningful creative relationships.",
      path:"/blogs",
      action:"Connect",
     },
]



export const shop =[
  {
    id:1,
    title:"Structures of Light",
    image:product_1
  },
  {
    id:2,
    title:"LWBL Signature Hoodie",
    image:product_2,
    tagLine:"Lightweave Beacon Legacy Signature White Hoodie T-Shirt",
    description:"Celebrate your love for art and artists with Lightweave Beacon Legacy Signature White Hoodie. Designed with our signature hoodie, this tee is more than just apparel—it’s a statement of creativity and courage. Crafted from 100% soft cotton, the shirt ensures maximum comfort, whether you’re curled up with your favorite art, drafting your next masterpiece, or stepping out with friends. Its sleek unisex design makes it versatile, stylish, and perfect for anyone who’s part of Lightweave Beacon Legacy community. Wear your passion. Share your story.",
    highlights:["Premium 100% Cotton – soft, breathable & durable"," Minimalist design (embroidered-style print)"," Minimalist design (embroidered-style print)",
        " Lightweight & comfortable for all-day wear"," Unisex fit – suitable for both men and women",
" Perfect for artist, painters, and art lovers", " Machine-washable, fade-resistant print"
    ],
    size:["small", "Medium", "Large","XL"],
    price:"$28.99",
    previous_Price:"$100",
   reviews :[
  { id: 1, name: "Ayesha Khan", comment: "The product quality exceeded my expectations. Packaging was neat and delivery was on time. Definitely recommended!",avatar:women },
  { id: 2, name: "Mohammad Ali", comment: "Very satisfied with this purchase. The build quality is solid and it works exactly as described",avatar:male },
  { id: 3, name: "Sara Ahmed", comment: "I was unsure at first, but now I’m really impressed with the performance.",avatar:women },
  { id: 4, name: "Usman Raza", comment: "Good value for money and fast delivery.",avatar:male },
  { id: 5, name: "Fatima Noor", comment: "Simple, clean, and effective product." ,avatar:women},
  { id: 6, name: "Hassan Malik", comment: "Excellent quality and smooth experience.",avatar:male },
  { id: 7, name: "Zainab Iqbal", comment: "Looks premium and works well." ,avatar:women},
  { id: 8, name: "Bilal Siddiqui", comment: "Exactly what I was looking for." ,avatar:male},
  { id: 9, name: "Maryam Sheikh", comment: "Easy to use and setup was quick." ,avatar:women},
  { id: 10, name: "Ahmed Farooq", comment: "Highly recommended product!",avatar:male },
],
  properties:[
    {id:1,title:"Machine wash cold, inside out", icon:D_icon_1},
    {id:2,title:"Do not bleach", icon:D_icon_2},
    {id:3,title:"Tumble dry low or hang dry", icon:D_icon_3},
    {id:4,title:"Iron inside out if needed", icon:D_icon_4},
    {id:5,title:"Do not dry clean", icon:D_icon_5},
  ]
  },
  {
    id:3,
    title:"Gallery-Scale Landscape Print",
    image:product_3
  },
  {
    id:4,
    title:"Artist Spotlight Piece",
    image:product_4
  },
]


export const help=[
   {
    id:1,
    title:"General Questions",
    detail:"For mission-related inquiries, platform navigation, or foundation information.",
   },
   {
    id:2,
    title:"Challenges & Submissions",
    detail:"Questions about upcoming challenges, submission guidelines, or feedback timelines.",
   },
   {
    id:3,
    title:"Education & Resources",
    detail:"Support for tutorials, workshops, masterclasses, and learning materials.",
   },
   {
    id:4,
    title:"Membership & Billing",
    detail:"Help with account access, subscriptions, upgrades, or payment issues.",
   },
   {
    id:5,
    title:"Partnerships & Sponsorships",
    detail:"Inquiries from educators, donors, sponsors, and organizations.",
   },
]


export const support =[
     {
       id:1,
       title:"Funds micro-grants and creative awards", 
     },
     {
       id:2,
       title:"Supports educational resources and workshops", 
     },
     {
       id:3,
       title:"Keeps public challenges accessible", 
     },
     {
       id:4,
       title:"Provides constructive feedback and mentorship", 
     },
     {
       id:5,
       title:"Strengthens a safe, inclusive creative community", 
     },
]


export const Where_donation=[
   {
    id:1,
    title:"Artist Grants & Micro-Grants",
    detail:"Direct financial support for creative projects and development.",
   },
   {
    id:2,
    title:"Education & Learning Programs",
    detail:"Tutorials, masterclasses, and critique-based learning.",
   },
   {
    id:3,
    title:"Creative Challenges & Exhibitions",
    detail:"Funding challenge prizes, galleries, and exhibitions.",
   },
   {
    id:4,
    title:"Platform Maintenance & Security",
    detail:"Ensuring a safe, secure, and accessible digital environment.",
   },
   {
    id:5,
    title:"Community Growth & Outreach",
    detail:"Expanding access to underrepresented and remote communities.",
   },
]



export const properties=[
    {id:1,title:"Machine wash cold, inside out", icon:D_icon_1},
    {id:2,title:"Do not bleach", icon:D_icon_2},
    {id:3,title:"Tumble dry low or hang dry", icon:D_icon_3},
    {id:4,title:"Iron inside out if needed", icon:D_icon_4},
    {id:5,title:"Do not dry clean", icon:D_icon_5},
  ]


  export const reviews =[
  { id: 1, name: "Ayesha Khan", date:"5 Days ago", rating:4, comment: "The product quality exceeded my expectations. Packaging was neat and delivery was on time. Definitely recommended!",avatar:women },
  { id: 2, name: "Mohammad Ali",date:"1 Days ago", rating:4.5, comment: "Very satisfied with this purchase. The build quality is solid and it works exactly as described",avatar:male },
  { id: 3, name: "Sara Ahmed",date:"2 Days ago", rating:5, comment: "I was unsure at first, but now I’m really impressed with the performance.",avatar:women },
  { id: 4, name: "Usman Raza",date:"5 Minute ago", rating:4.7, comment: "Good value for money and fast delivery.",avatar:male },
  { id: 5, name: "Fatima Noor",date:"1 Minute ago", rating:3.8, comment: "Simple, clean, and effective product." ,avatar:women},
  { id: 6, name: "Hassan Malik",date:"1 week ago",rating:3.4, comment: "Excellent quality and smooth experience.",avatar:male },
  { id: 7, name: "Zainab Iqbal",date:"1 Month ago",rating:4.9 ,comment: "Looks premium and works well." ,avatar:women},
  { id: 8, name: "Bilal Siddiqui",date:"2 Days ago", rating:4.5, comment: "Exactly what I was looking for." ,avatar:male},
  { id: 9, name: "Maryam Sheikh",date:"4 Days ago",rating:5 ,comment: "Easy to use and setup was quick." ,avatar:women},
  { id: 10, name: "Ahmed Farooq",date:"3 Days ago", rating:3.2,  comment: "Highly recommended product!",avatar:male },
]


export const user_Profile=[
    {id:1, label:"Profile", link:"/profile", icon:<CgProfile/>},
    {id:2, label:"Awards", link:"/awards", icon:<CgAwards/>},
    {id:3, label:"Badges", link:"/badges", icon:<SiOpenbadges/>},
    {id:4, label:"Education", link:"/education", icon:<MdOutlineCastForEducation/>},
    {id:5, label:"Messages", link:"/messages", icon:<LuMessageSquare />},
    {id:6, label:"Projects", link:"/projects", icon:<GrProjects/>},
    {id:7, label:"Quests", link:"/quests", icon:<FaQuestion/>},
    {id:8, label:"Quiz", link:"/quiz", icon:<MdQuiz/>},
]



export const projects = [
  {
    id: 1,
    projectBy: "Xyz Name",
    projectTitle: "Personal Portfolio Website",
    image: p_1,
    description: "A dynamic website to showcase your skills, projects, experience, and resume. Includes interactive sections, smooth scrolling, responsive design, and optional dark/light mode. Users can contact you directly via a contact form.",
    themeInspiration: "Minimalist, modern portfolios on Dribbble, Behance",
    primaryGoals: "Build an online presence, showcase personal projects, learn responsive design",
    skillAreas: "HTML, CSS, JavaScript, TailwindCSS, React, UI/UX Design",
    avatar:avatar,
    createdAt:"2026-01-14",
  },
  {
    id: 2,
    projectBy: "Xyz Name",
    projectTitle: "Task Management App",
    image: p_2,
    description: "A productivity application where users can add, edit, delete, and mark tasks as complete. Includes filters for completed/pending tasks and optional drag-and-drop reordering.",
    themeInspiration: "Productivity apps like Todoist, Microsoft To-Do",
    primaryGoals: "Learn CRUD operations, state management, and front-end interactivity",
    skillAreas: "React, Vue.js, LocalStorage, JavaScript, CSS",
    avatar:avatar,
    createdAt:"2026-01-20",
  },
  {
    id: 3,
    projectBy: "Xyz Name",
    projectTitle: "E-commerce Website",
    image: p_3,
    description: "A fully functional online store with product listing, search and filter options, shopping cart, and checkout with payment integration. Admin panel for managing products.",
    themeInspiration: "Amazon, Shopify, Flipkart",
    primaryGoals: "Learn full-stack development, payment gateway integration, product management",
    skillAreas: "React/Next.js, Node.js, Express, MongoDB, Stripe/PayPal, TailwindCSS",
    avatar:avatar,
    createdAt:"2026-01-24",
  },
  {
    id: 4,
    projectBy: "Xyz Name",
    projectTitle: "Blogging Platform",
    image: p_4,
    description: "A platform where users can register, create, edit, and delete blog posts. Supports rich text editor, image uploads, comments, likes, and user authentication.",
    themeInspiration: "Medium, Dev.to",
    primaryGoals: "Learn CRUD operations, authentication, and dynamic content management",
    skillAreas: "MERN Stack, MongoDB, Node.js, Express, React, JWT Authentication",
    avatar:avatar,
    createdAt:"2026-02-08",
  },
  {
    id: 5,
    projectBy: "Xyz Name",
    projectTitle: "Quiz App",
    image: p_5,
    description: "An interactive quiz platform where users can take multiple-choice quizzes with timers. Tracks scores and rankings, and allows admins to create new quizzes.",
    themeInspiration: "Kahoot, Quizizz",
    primaryGoals: "Learn dynamic rendering, form handling, and interactive UI",
    skillAreas: "React, Firebase, Node.js, JavaScript, CSS",
    avatar:avatar,
    createdAt:"2026-01-12",
  },
  {
    id: 6,
    projectBy: "Xyz Name",
    projectTitle: "Recipe Sharing Website",
    image: p_6,
    description: "Users can submit, search, edit, and save recipes. Includes categories, ingredient filters, and favorite recipes functionality. Images are uploaded for each recipe.",
    themeInspiration: "Allrecipes, Tasty, Food blogs",
    primaryGoals: "Practice CRUD operations, file uploads, and database queries",
    skillAreas: "React, Node.js, MongoDB, Cloudinary, Express, TailwindCSS",
    avatar:avatar,
    createdAt:"2026-01-15",
  },
  {
    id: 7,
    projectBy: "Xyz Name",
    projectTitle: "Social Media Dashboard",
    image: p_7,
    description: "A dashboard to track social media analytics like likes, followers, and engagement. Displays charts and trends over time. Supports multiple social media accounts.",
    themeInspiration: "Hootsuite, Buffer",
    primaryGoals: "Learn API integration, data visualization, and dashboard design",
    skillAreas: "React, Node.js, MongoDB, Chart.js, CSS, API handling",
    avatar:avatar,
    createdAt:"2026-01-0-12",
  },
  {
    id: 8,
    projectBy: "Xyz Name",
    projectTitle: "Event Management System",
    image: p_8,
    description: "Platform to create and manage events with registration, RSVPs, and calendar view. Users can view upcoming events and register online.",
    themeInspiration: "Eventbrite, Meetup",
    primaryGoals: "Learn form handling, dynamic scheduling, and calendar integration",
    skillAreas: "React, Node.js, MongoDB, FullCalendar.js, TailwindCSS",
    avatar:avatar,
    createdAt:"2026-01-02",
  },
  {
    id: 9,
    projectBy: "Xyz Name",
    projectTitle: "Online Learning Platform",
    image: p_9,
    description: "Users can enroll in courses, watch video lessons, track progress, take quizzes, and receive certificates. Includes course catalog, search, and payment integration.",
    themeInspiration: "Coursera, Udemy",
    primaryGoals: "Learn video embedding, progress tracking, and secure authentication",
    skillAreas: "Next.js, Node.js, MongoDB, Stripe, React, TailwindCSS",
    avatar:avatar,
    createdAt:"2026-01-17",
  },
  {
    id: 10,
    projectBy: "Xyz Name",
    projectTitle: "Real-time Chat Application",
    image: p_10,
    description: "Users can chat with friends or in groups in real-time. Features online/offline status, message notifications, and chat history.",
    themeInspiration: "WhatsApp Web, Slack",
    primaryGoals: "Learn real-time data handling, WebSockets, and authentication",
    skillAreas: "React, Node.js, Socket.io, MongoDB, Express, CSS",
    avatar:avatar,
    createdAt:"2026-01-27",
  }
];



export const quizs =[
   {
    id:1,
  title: "JavaScript Fundamentals Quiz",
  description: "Test your knowledge of core JavaScript concepts.",
  questions: [
    {
      questionText: "Which company developed JavaScript?",
      type: "single",
      options: ["Microsoft", "Netscape", "Google", "IBM"],
      correctAnswers: [1]
    },
    {
      questionText: "Which of the following are JavaScript data types?",
      type: "multiple",
      options: ["String", "Boolean", "Float", "Undefined"],
      correctAnswers: [0,1,3]
    },
    {
      questionText: "JavaScript is a statically typed language.",
      type: "true_false",
      options: ["True", "False"],
      correctAnswers: [1]
    }
  ]
},
{
  id:2, 
  title: "React JS Basics Quiz",
  description: "Assess your understanding of React fundamentals.",
  questions: [
    {
      questionText: "What is JSX?",
      type: "single",
      options: ["JavaScript XML", "Java Syntax Extension", "JSON XML", "None"],
      correctAnswers: [0]
    },
    {
      questionText: "Which hook is used for state?",
      type: "single",
      options: ["useEffect", "useState", "useRef", "useMemo"],
      correctAnswers: [1]
    },
    {
      questionText: "React is developed by Facebook.",
      type: "true_false",
      options: ["True", "False"],
      correctAnswers: [0]
    }
  ]
},
{
  id:3,
  title: "Node.js Backend Quiz",
  description: "Backend development knowledge test.",
  questions: [
    {
      questionText: "Node.js is built on which engine?",
      type: "single",
      options: ["SpiderMonkey", "V8", "Chakra", "Java VM"],
      correctAnswers: [1]
    },
    {
      questionText: "Which are Express middleware functions?",
      type: "multiple",
      options: ["req", "res", "next", "router"],
      correctAnswers: [0,1,2]
    },
    {
      questionText: "Node.js supports non-blocking I/O.",
      type: "true_false",
      options: ["True", "False"],
      correctAnswers: [0]
    }
  ]
},
{
  id:4,
  title: "MongoDB Database Quiz",
  description: "Test your MongoDB knowledge.",
  questions: [
    {
      questionText: "MongoDB is a ____ database.",
      type: "single",
      options: ["Relational", "NoSQL", "Graph", "SQL"],
      correctAnswers: [1]
    },
    {
      questionText: "Which command inserts a document?",
      type: "single",
      options: ["insertOne()", "add()", "create()", "push()"],
      correctAnswers: [0]
    },
    {
      questionText: "MongoDB stores data in BSON format.",
      type: "true_false",
      options: ["True", "False"],
      correctAnswers: [0]
    }
  ]
},
{
  id:5,
  title: "HTML & CSS Basics Quiz",
  description: "Frontend structure and styling test.",
  questions: [
    {
      questionText: "Which tag is used for hyperlinks?",
      type: "single",
      options: ["<a>", "<link>", "<href>", "<url>"],
      correctAnswers: [0]
    },
    {
      questionText: "Which are CSS position values?",
      type: "multiple",
      options: ["absolute", "fixed", "center", "relative"],
      correctAnswers: [0,1,3]
    },
    {
      questionText: "CSS stands for Cascading Style Sheets.",
      type: "true_false",
      options: ["True", "False"],
      correctAnswers: [0]
    }
  ]
},
{
  id:6,
  title: "Cybersecurity Fundamentals Quiz",
  description: "Security awareness and basic cybersecurity.",
  questions: [
    {
      questionText: "What does HTTPS stand for?",
      type: "single",
      options: [
        "HyperText Transfer Protocol Secure",
        "High Transfer Text Protocol",
        "Hyper Tool Transfer Secure",
        "None"
      ],
      correctAnswers: [0]
    },
    {
      questionText: "Which are common cyber attacks?",
      type: "multiple",
      options: ["Phishing", "SQL Injection", "Firewall", "DDoS"],
      correctAnswers: [0,1,3]
    },
    {
      questionText: "Strong passwords improve security.",
      type: "true_false",
      options: ["True", "False"],
      correctAnswers: [0]
    }
  ]
},
]
